var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRaumstrahlend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "151px",
    viewBox: "0 0 73 151",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon raumstrahlend") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-83.9%",
    y: "-23.9%",
    width: "267.7%",
    height: "147.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M10,34 L21,34 L31,109 L0,109 L10,34 Z M10,32 L21,32 L31,0 L0,0 L10,32 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-19.4%",
    y: "-5.5%",
    width: "138.7%",
    height: "111.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prototyp-Konfigurator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Einstieg-in-den-Konfigurator---Basiskonfiguration-Purelite-Slim",
    transform: "translate(-676.000000, -594.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(270.000000, 506.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(390.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-raumstrahlend",
    filter: "url(#filter-1)",
    transform: "translate(37.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    x: -23,
    y: 2,
    width: 76,
    height: 105
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EAEAEA",
    x: 5,
    y: 30,
    width: 22,
    height: 6
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRaumstrahlend);
export default __webpack_public_path__ + "static/media/icon_raumstrahlend.e4c62f4a24eebcfc53b9aaabcbbd0514.svg";
export { ForwardRef as ReactComponent };